export default __webpack_public_path__ + "static/media/DonutChartBlue.df188545.svg";